import * as passport from "passport";
import { Strategy as SamlStrategy } from "./passport-saml";
import { Profile, VerifiedCallback } from "./passport-saml/types";

function findByEmail(email: string, cb: VerifiedCallback) {
  cb(null);
}

passport.use(
  new SamlStrategy(
    {
      path: "/login/callback",
      entryPoint:
        "https://openidp.feide.no/simplesaml/saml2/idp/SSOService.php",
      issuer: "passport-saml",
    },
    function (profile: Profile | null | undefined, done: VerifiedCallback) {
      if (profile != null && typeof profile.email === "string") {
        findByEmail(profile.email, function (err, user) {
          if (err) {
            return done(err);
          }
          return done(null, user);
        });
      }
    }
  )
);
